import { inject, Pipe, PipeTransform } from '@angular/core';
import { QrCode } from '@cue/navigation-services';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'poisCanBeShownInResource',
  standalone: true,
})
export class PoisCanBeShownInResourcePipe implements PipeTransform {
  translocoService = inject(TranslocoService);

  transform(qrCodeList: QrCode[]): QrCode[] {
    if (qrCodeList) {
      return qrCodeList.filter((x) => x.showInResourceDetail);
    }
    return [];
  }
}
